module.exports = "img/flags/TZ.8ccab05.png";